import { of } from 'rxjs'
import { delayWhen, ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import * as Actions from 'store/actions/index.ts'
import {
  getIsSaleFetched,
  getSaleProvider,
  getTemplate
} from 'store/selectors'
import mixPanel from 'tracking/mixPanel'
import { awaitForSaleFetched } from '../../helpers/resources'
import { DEFAULT_MIXPANEL_DATA } from './constants'

const getMPData = (state) => ({
  ...DEFAULT_MIXPANEL_DATA,
  'Offer Provider': getSaleProvider(state),
  'TSF Template version': getTemplate(state)
})

const initMixpanelEpic = (
  actions$,
  state$
) => actions$.pipe(
  ofType(Actions.tracking.INIT_MIXPANEL),
  delayWhen(() => getIsSaleFetched(state$.value)
    ? of({})
    : awaitForSaleFetched(actions$, state$)
  ),
  tap(({ payload: { i18nProperties, mixPanelTracker }, type }) => {
    console.warn('Only one Mixpanel endpoint format should be managed')
    const mixPanelTrackerURL = (mixPanelTracker.url && mixPanelTracker.url.slice(-1) === '/')
      ? mixPanelTracker.url.slice(0, -1)
      : mixPanelTracker.url

    mixPanel
      .registerForAppSession({
        ...getMPData(state$.value),
        ...i18nProperties
      })
      .init(
        mixPanelTracker.token,
        {
          api_host: mixPanelTrackerURL || undefined,
          batch_requests: false
        }
      )
  }),
  ignoreElements()
)

export default initMixpanelEpic
